<template>
  <div class="home">
    <div v-if="loadingCodeInfo">Laddar lite information...</div>
    <div v-else>
      <div v-if="!codeSuccess">
        <div><strong>Ojsan!</strong></div>
        <p>Din kod är ogiltlig vilket ställer till det lite. Prova igen. Annars kontakta support@nexa.se.</p>
      </div>
      <div v-else>
        Din e-post är nu bytt från {{ fromEmail }} till {{ toEmail }}.
      </div>
    </div>
  </div>
</template>

<style>
.home {
  margin:12px;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {},
  created () {

  },
  mounted () {
    fetch(`https://api.systemnexa2.se/1/account/email/confirm?code=${this.$route.params.code}`)
    .then(res => res.json())
    .then(json => {
      this.codeSuccess = json.success
      if (this.codeSuccess) {
        this.fromEmail = json.data.fromEmail
        this.toEmail = json.data.toEmail
      }

      this.loadingCodeInfo = false
    })
  },
  data: () => ({
    fromEmail: '',
    toEmail: '',
    loadingCodeInfo: true,
    codeSuccess: false,
  }),
  methods: {}
}
</script>
